export const getSmscForVendor = (builder) => ({
    getSmscForVendor: builder.mutation({
      query: ({ vendor_id }) => {
        const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
        return {
          url: `/drop_down_smsc`,
          method: "GET",
          params: { vendor_id },
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        };
      },
    }),
  });
  